import { createFileRoute } from '@tanstack/react-router'
import { AnalyticsShell } from '../../../modules/analytics/analytics-shell'
import { DashboardOverviewPage } from '../../../modules/analytics/dashboard-overview-page'
// Side-effect: register the record-analytics cards (also done at boot; harmless to repeat).
import '../../../modules/analytics/register-record-charts'

/**
 * `/analytics/` - the analytics dashboard overview (NLQ bar + dashboard
 * composer), the standalone analytics module landing surface.
 */
export const Route = createFileRoute('/_authed/analytics/')({
  component: () => (
    <AnalyticsShell padded>
      <DashboardOverviewPage />
    </AnalyticsShell>
  ),
})
